export const translations = {
  de: {
    nav: {
      home: "Startseite",
      rooms: "Zimmer",
      services: "Dienstleistungen",
      location: "Lage",
      contact: "Kontakt",
      book: "Jetzt buchen"
    },
    hero: {
      title: "Golf Hotel Des Alpes",
      subtitle: "Ihr alpiner Rückzugsort im Herzen des Engadins",
      cta: "Zimmer entdecken"
    },
    about: {
      title: "Willkommen im Golf Hotel Des Alpes",
      description: "Das Golf Hotel Des Alpes befindet sich im Engadin, im Zentrum von Samedan. Das Hotel verfügt über 40 Zimmer und im Inneren über eine typisch römische Trattoria sowie eine charakteristische Bar mit Raucherbereich, wo Sie den Abend verbringen können.",
      features: {
        rooms: "40 Zimmer",
        restaurant: "Römische Trattoria",
        bar: "Charakteristische Bar",
        petFriendly: "Haustierfreundlich"
      }
    },
    rooms: {
      title: "Unsere Zimmer",
      subtitle: "Komfort und Eleganz mit Blick auf die Alpen",
      standard: {
        name: "Standard Zimmer",
        size: "18 m²",
        description: "Das Standardzimmer bietet Komfort und Funktionalität. Es verfügt über ein Doppelbett, ein eigenes Bad mit Dusche und Haartrockner, einen Schreibtisch und einen Flachbildfernseher."
      },
      superior: {
        name: "Superior Zimmer",
        size: "20 m²",
        description: "Das Superior Zimmer bietet etwa 20 Quadratmeter mit einem komfortablen Doppelbett, eigenem Bad mit Dusche und Haartrockner, Schreibtisch und Flachbildfernseher."
      },
      mountainView: {
        name: "Zimmer mit Bergblick",
        size: "22 m²",
        description: "Das Zimmer mit Bergblick bietet etwa 22 Quadratmeter. Das grosse Doppelbett sorgt für erholsamen Schlaf, während die grossen Fenster einen herrlichen Blick auf die Berglandschaft bieten."
      },
      balcony: {
        name: "Zimmer mit Balkon & Panoramablick",
        size: "24 m²",
        description: "Das Zimmer mit Balkon und Panoramablick auf die Berge bietet etwa 24 Quadratmeter und vereint Komfort mit natürlicher Schönheit. Der private Balkon ist ideal zum Entspannen im Freien."
      },
      family: {
        name: "Familienzimmer",
        size: "36 m²",
        description: "Das Familienzimmer ist perfekt für den Bergurlaub und besteht aus zwei verbundenen Zimmern mit Doppelbett und Etagenbett, eigenem Bad mit Dusche und Haartrockner."
      },
      amenities: {
        doubleBed: "Doppelbett",
        bathroom: "Eigenes Bad",
        tv: "Flachbildfernseher",
        desk: "Schreibtisch",
        balcony: "Balkon",
        mountainView: "Bergblick",
        bunkBed: "Etagenbett"
      }
    },
    services: {
      title: "Dienstleistungen & Annehmlichkeiten",
      subtitle: "Alles für Ihren perfekten Aufenthalt",
      breakfast: {
        title: "Frühstücksbuffet",
        description: "Starten Sie Ihren Tag mit unserem reichhaltigen Frühstücksbuffet oder wählen Sie Halbpension."
      },
      restaurant: {
        title: "Römische Trattoria",
        description: "Geniessen Sie authentische römische Küche in unserem charakteristischen Restaurant."
      },
      bar: {
        title: "Charakteristische Bar",
        description: "Entspannen Sie sich in unserer gemütlichen Bar mit Raucherbereich."
      },
      pets: {
        title: "Haustierfreundlich",
        description: "Ihre vierbeinigen Freunde sind bei uns willkommen (15 CHF pro Tag)."
      },
      ski: {
        title: "Skilift in der Nähe",
        description: "Kinderskilift in wenigen Schritten erreichbar. Alle Skigebiete mit Bus oder Bahn erreichbar."
      },
      golf: {
        title: "Golfplatz",
        description: "Der renommierte Golfplatz ist nur etwa 700 Meter entfernt."
      }
    },
    location: {
      title: "Lage & Erreichbarkeit",
      subtitle: "Im Herzen von Samedan, Engadin",
      train: "Bahnhof ca. 500m",
      bus: "Bushaltestelle ca. 100m",
      golf: "Golfplatz ca. 700m",
      ski: "Kinderskilift wenige Schritte",
      address: "Via San Bastiaun 25, 7503 Samedan, Schweiz"
    },
    contact: {
      title: "Kontakt",
      subtitle: "Wir freuen uns auf Ihre Nachricht",
      phone: "Telefon / WhatsApp",
      email: "E-Mail",
      address: "Adresse",
      company: "San Bastiaun Hospitality & Services GmbH",
      companyAddress: "Via Surtour, 1 - 7503 Samedan - CH",
      vatNumber: "CHE-205.322.392"
    },
    footer: {
      followUs: "Folgen Sie uns",
      rights: "Alle Rechte vorbehalten"
    },
    gdpr: {
      title: "Cookie-Einstellungen",
      description: "Wir verwenden Cookies, um Ihnen das beste Erlebnis auf unserer Website zu bieten. Sie können wählen, welche Cookies Sie akzeptieren möchten.",
      necessary: "Notwendige Cookies",
      necessaryDesc: "Diese Cookies sind für das Funktionieren der Website unerlässlich.",
      analytics: "Analytische Cookies",
      analyticsDesc: "Helfen uns zu verstehen, wie Besucher mit der Website interagieren.",
      marketing: "Marketing-Cookies",
      marketingDesc: "Werden verwendet, um Besuchern relevante Werbung anzuzeigen.",
      acceptAll: "Alle akzeptieren",
      acceptSelected: "Auswahl akzeptieren",
      rejectAll: "Alle ablehnen",
      settings: "Cookie-Einstellungen",
      privacyPolicy: "Datenschutzerklärung",
      privacyTitle: "Datenschutzerklärung",
      privacyContent: `
        <h3>1. Verantwortlicher</h3>
        <p>San Bastiaun Hospitality & Services GmbH<br/>Via Surtour, 1 - 7503 Samedan - CH<br/>CHE-205.322.392</p>
        
        <h3>2. Erhebung und Verarbeitung von Daten</h3>
        <p>Wir erheben personenbezogene Daten nur, wenn Sie uns diese freiwillig mitteilen, z.B. bei einer Buchungsanfrage oder Kontaktaufnahme.</p>
        
        <h3>3. Verwendung von Cookies</h3>
        <p>Unsere Website verwendet Cookies. Notwendige Cookies sind für die Grundfunktionen der Website erforderlich. Analytische Cookies helfen uns, die Nutzung der Website zu verstehen.</p>
        
        <h3>4. Ihre Rechte</h3>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten. Kontaktieren Sie uns unter desalpes@sbhsgroup.ch</p>
        
        <h3>5. Kontakt</h3>
        <p>Bei Fragen zum Datenschutz kontaktieren Sie uns bitte unter:<br/>E-Mail: desalpes@sbhsgroup.ch<br/>Tel: +41 78 262 07 40</p>
      `
    },
    chatPopup: {
      title: "Nutzen Sie unsere KI",
      description: "Unser KI-Assistent hilft Ihnen gerne bei Fragen zu Zimmern, Verfügbarkeit und Buchungen.",
      button: "KI starten",
      close: "Später"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      rooms: "Chambres",
      services: "Services",
      location: "Emplacement",
      contact: "Contact",
      book: "Réserver"
    },
    hero: {
      title: "Golf Hotel Des Alpes",
      subtitle: "Votre refuge alpin au cœur de l'Engadine",
      cta: "Découvrir les chambres"
    },
    about: {
      title: "Bienvenue au Golf Hotel Des Alpes",
      description: "Le Golf Hotel Des Alpes est situé en Engadine, au centre de Samedan. L'hôtel dispose de 40 chambres et à l'intérieur d'une trattoria romaine typique ainsi qu'un bar caractéristique avec espace fumeurs.",
      features: {
        rooms: "40 Chambres",
        restaurant: "Trattoria Romaine",
        bar: "Bar Caractéristique",
        petFriendly: "Animaux Bienvenus"
      }
    },
    rooms: {
      title: "Nos Chambres",
      subtitle: "Confort et élégance avec vue sur les Alpes",
      standard: {
        name: "Chambre Standard",
        size: "18 m²",
        description: "La chambre standard offre confort et fonctionnalité. Elle dispose d'un lit double, d'une salle de bain privée avec douche et sèche-cheveux, d'un bureau et d'une télévision à écran plat."
      },
      superior: {
        name: "Chambre Supérieure",
        size: "20 m²",
        description: "La chambre supérieure offre environ 20 mètres carrés avec un lit double confortable, salle de bain privée avec douche et sèche-cheveux, bureau et télévision à écran plat."
      },
      mountainView: {
        name: "Chambre Vue Montagne",
        size: "22 m²",
        description: "La chambre avec vue sur les montagnes offre environ 22 mètres carrés. Le grand lit double assure un repos réparateur, tandis que les grandes fenêtres offrent une vue magnifique."
      },
      balcony: {
        name: "Chambre avec Balcon & Vue Panoramique",
        size: "24 m²",
        description: "La chambre avec balcon et vue panoramique sur les montagnes offre environ 24 mètres carrés, alliant confort et beauté naturelle."
      },
      family: {
        name: "Chambre Familiale",
        size: "36 m²",
        description: "La chambre familiale est parfaite pour les vacances en montagne, composée de deux chambres communicantes avec lit double et lits superposés."
      },
      amenities: {
        doubleBed: "Lit double",
        bathroom: "Salle de bain privée",
        tv: "TV écran plat",
        desk: "Bureau",
        balcony: "Balcon",
        mountainView: "Vue montagne",
        bunkBed: "Lits superposés"
      }
    },
    services: {
      title: "Services & Commodités",
      subtitle: "Tout pour un séjour parfait",
      breakfast: {
        title: "Petit-déjeuner Buffet",
        description: "Commencez votre journée avec notre petit-déjeuner buffet ou choisissez la demi-pension."
      },
      restaurant: {
        title: "Trattoria Romaine",
        description: "Savourez une cuisine romaine authentique dans notre restaurant caractéristique."
      },
      bar: {
        title: "Bar Caractéristique",
        description: "Détendez-vous dans notre bar confortable avec espace fumeurs."
      },
      pets: {
        title: "Animaux Bienvenus",
        description: "Vos amis à quatre pattes sont les bienvenus (15 CHF par jour)."
      },
      ski: {
        title: "Téléski à Proximité",
        description: "Téléski pour enfants à quelques pas. Tous les domaines skiables accessibles en bus ou train."
      },
      golf: {
        title: "Terrain de Golf",
        description: "Le terrain de golf renommé est à seulement 700 mètres environ."
      }
    },
    location: {
      title: "Emplacement & Accessibilité",
      subtitle: "Au cœur de Samedan, Engadine",
      train: "Gare env. 500m",
      bus: "Arrêt de bus env. 100m",
      golf: "Terrain de golf env. 700m",
      ski: "Téléski enfants à quelques pas",
      address: "Via San Bastiaun 25, 7503 Samedan, Suisse"
    },
    contact: {
      title: "Contact",
      subtitle: "Nous nous réjouissons de votre message",
      phone: "Téléphone / WhatsApp",
      email: "E-mail",
      address: "Adresse",
      company: "San Bastiaun Hospitality & Services GmbH",
      companyAddress: "Via Surtour, 1 - 7503 Samedan - CH",
      vatNumber: "CHE-205.322.392"
    },
    footer: {
      followUs: "Suivez-nous",
      rights: "Tous droits réservés"
    },
    gdpr: {
      title: "Paramètres des cookies",
      description: "Nous utilisons des cookies pour vous offrir la meilleure expérience sur notre site. Vous pouvez choisir les cookies que vous souhaitez accepter.",
      necessary: "Cookies nécessaires",
      necessaryDesc: "Ces cookies sont essentiels au fonctionnement du site.",
      analytics: "Cookies analytiques",
      analyticsDesc: "Nous aident à comprendre comment les visiteurs interagissent avec le site.",
      marketing: "Cookies marketing",
      marketingDesc: "Utilisés pour afficher des publicités pertinentes aux visiteurs.",
      acceptAll: "Tout accepter",
      acceptSelected: "Accepter la sélection",
      rejectAll: "Tout refuser",
      settings: "Paramètres des cookies",
      privacyPolicy: "Politique de confidentialité",
      privacyTitle: "Politique de confidentialité",
      privacyContent: `
        <h3>1. Responsable</h3>
        <p>San Bastiaun Hospitality & Services GmbH<br/>Via Surtour, 1 - 7503 Samedan - CH<br/>CHE-205.322.392</p>
        
        <h3>2. Collecte et traitement des données</h3>
        <p>Nous ne collectons des données personnelles que lorsque vous nous les communiquez volontairement, par exemple lors d'une demande de réservation ou d'un contact.</p>
        
        <h3>3. Utilisation des cookies</h3>
        <p>Notre site utilise des cookies. Les cookies nécessaires sont requis pour les fonctions de base du site. Les cookies analytiques nous aident à comprendre l'utilisation du site.</p>
        
        <h3>4. Vos droits</h3>
        <p>Vous avez le droit d'accès, de rectification, de suppression et de limitation du traitement de vos données. Contactez-nous à desalpes@sbhsgroup.ch</p>
        
        <h3>5. Contact</h3>
        <p>Pour toute question relative à la protection des données, veuillez nous contacter:<br/>E-mail: desalpes@sbhsgroup.ch<br/>Tél: +41 78 262 07 40</p>
      `
    },
    chatPopup: {
      title: "Utilisez notre IA",
      description: "Notre assistant IA vous aidera volontiers pour toutes questions sur les chambres, la disponibilité et les réservations.",
      button: "Lancer l'IA",
      close: "Plus tard"
    }
  },
  en: {
    nav: {
      home: "Home",
      rooms: "Rooms",
      services: "Services",
      location: "Location",
      contact: "Contact",
      book: "Book Now"
    },
    hero: {
      title: "Golf Hotel Des Alpes",
      subtitle: "Your Alpine Retreat in the Heart of Engadin",
      cta: "Discover Rooms"
    },
    about: {
      title: "Welcome to Golf Hotel Des Alpes",
      description: "The Golf Hotel Des Alpes is located in the Engadin, in the centre of Samedan. The hotel has 40 rooms and features a typical Roman trattoria as well as a characteristic bar with smoking area where you can spend the evening.",
      features: {
        rooms: "40 Rooms",
        restaurant: "Roman Trattoria",
        bar: "Characteristic Bar",
        petFriendly: "Pet Friendly"
      }
    },
    rooms: {
      title: "Our Rooms",
      subtitle: "Comfort and Elegance with Alpine Views",
      standard: {
        name: "Standard Room",
        size: "18 m²",
        description: "The standard room offers comfort and functionality. It features a double bed, private bathroom with shower and hairdryer, desk and flat-screen TV."
      },
      superior: {
        name: "Superior Room",
        size: "20 m²",
        description: "The superior room offers approximately 20 square metres with a comfortable double bed, private bathroom with shower and hairdryer, desk and flat-screen TV."
      },
      mountainView: {
        name: "Mountain View Room",
        size: "22 m²",
        description: "The mountain view room offers approximately 22 square metres. The large double bed ensures restful sleep, while the large windows offer magnificent views of the surrounding landscape."
      },
      balcony: {
        name: "Balcony Room with Panoramic View",
        size: "24 m²",
        description: "The room with balcony and panoramic mountain views offers approximately 24 square metres, combining comfort with natural beauty. The private balcony is ideal for relaxing outdoors."
      },
      family: {
        name: "Family Room",
        size: "36 m²",
        description: "The family room is perfect for mountain holidays, consisting of two connecting rooms with double bed and bunk beds, private bathroom with shower and hairdryer."
      },
      amenities: {
        doubleBed: "Double Bed",
        bathroom: "Private Bathroom",
        tv: "Flat-screen TV",
        desk: "Desk",
        balcony: "Balcony",
        mountainView: "Mountain View",
        bunkBed: "Bunk Bed"
      }
    },
    services: {
      title: "Services & Amenities",
      subtitle: "Everything for Your Perfect Stay",
      breakfast: {
        title: "Breakfast Buffet",
        description: "Start your day with our rich breakfast buffet or choose half board."
      },
      restaurant: {
        title: "Roman Trattoria",
        description: "Enjoy authentic Roman cuisine in our characteristic restaurant."
      },
      bar: {
        title: "Characteristic Bar",
        description: "Relax in our cosy bar with smoking area."
      },
      pets: {
        title: "Pet Friendly",
        description: "Your four-legged friends are welcome (15 CHF per day)."
      },
      ski: {
        title: "Ski Lift Nearby",
        description: "Children's ski lift just steps away. All ski areas accessible by bus or train."
      },
      golf: {
        title: "Golf Course",
        description: "The renowned golf course is only about 700 metres away."
      }
    },
    location: {
      title: "Location & Accessibility",
      subtitle: "In the Heart of Samedan, Engadin",
      train: "Train station approx. 500m",
      bus: "Bus stop approx. 100m",
      golf: "Golf course approx. 700m",
      ski: "Children's ski lift steps away",
      address: "Via San Bastiaun 25, 7503 Samedan, Switzerland"
    },
    contact: {
      title: "Contact",
      subtitle: "We Look Forward to Hearing from You",
      phone: "Phone / WhatsApp",
      email: "Email",
      address: "Address",
      company: "San Bastiaun Hospitality & Services GmbH",
      companyAddress: "Via Surtour, 1 - 7503 Samedan - CH",
      vatNumber: "CHE-205.322.392"
    },
    footer: {
      followUs: "Follow Us",
      rights: "All Rights Reserved"
    },
    gdpr: {
      title: "Cookie Settings",
      description: "We use cookies to provide you with the best experience on our website. You can choose which cookies you want to accept.",
      necessary: "Necessary Cookies",
      necessaryDesc: "These cookies are essential for the website to function.",
      analytics: "Analytics Cookies",
      analyticsDesc: "Help us understand how visitors interact with the website.",
      marketing: "Marketing Cookies",
      marketingDesc: "Used to display relevant advertisements to visitors.",
      acceptAll: "Accept All",
      acceptSelected: "Accept Selected",
      rejectAll: "Reject All",
      settings: "Cookie Settings",
      privacyPolicy: "Privacy Policy",
      privacyTitle: "Privacy Policy",
      privacyContent: `
        <h3>1. Data Controller</h3>
        <p>San Bastiaun Hospitality & Services GmbH<br/>Via Surtour, 1 - 7503 Samedan - CH<br/>CHE-205.322.392</p>
        
        <h3>2. Data Collection and Processing</h3>
        <p>We only collect personal data when you voluntarily provide it to us, such as when making a booking inquiry or contacting us.</p>
        
        <h3>3. Use of Cookies</h3>
        <p>Our website uses cookies. Necessary cookies are required for basic website functions. Analytics cookies help us understand how the website is used.</p>
        
        <h3>4. Your Rights</h3>
        <p>You have the right to access, rectify, delete, and restrict the processing of your data. Contact us at desalpes@sbhsgroup.ch</p>
        
        <h3>5. Contact</h3>
        <p>For any questions regarding data protection, please contact us at:<br/>Email: desalpes@sbhsgroup.ch<br/>Tel: +41 78 262 07 40</p>
      `
    },
    chatPopup: {
      title: "Use our AI",
      description: "Our AI assistant will help you with questions about rooms, availability and bookings.",
      button: "Start AI",
      close: "Later"
    }
  },
  it: {
    nav: {
      home: "Home",
      rooms: "Camere",
      services: "Servizi",
      location: "Posizione",
      contact: "Contatti",
      book: "Prenota"
    },
    hero: {
      title: "Golf Hotel Des Alpes",
      subtitle: "Il vostro rifugio alpino nel cuore dell'Engadina",
      cta: "Scopri le camere"
    },
    about: {
      title: "Benvenuti al Golf Hotel Des Alpes",
      description: "Il Golf Hotel Des Alpes si trova in Engadina, nel centro di Samedan. L'hotel dispone di 40 camere e, al suo interno, di una trattoria tipicamente romana e di un bar caratteristico con area fumatori, dove è possibile trascorrere la serata.",
      features: {
        rooms: "40 Camere",
        restaurant: "Trattoria Romana",
        bar: "Bar Caratteristico",
        petFriendly: "Pet Friendly"
      }
    },
    rooms: {
      title: "Le Nostre Camere",
      subtitle: "Comfort ed eleganza con vista sulle Alpi",
      standard: {
        name: "Camera Standard",
        size: "18 m²",
        description: "La camera standard, con una superficie di circa 18 metri quadri, è pensata per offrire comfort ed essenzialità. Al suo interno troverai un letto matrimoniale accogliente, bagno privato con doccia e asciugacapelli, scrivania e televisore a schermo piatto."
      },
      superior: {
        name: "Camera Superior",
        size: "20 m²",
        description: "La camera Superior è di circa 20 metri quadri con un letto matrimoniale confortevole. Il bagno privato è dotato di una doccia e un asciugacapelli. La stanza include una scrivania e un televisore a schermo piatto."
      },
      mountainView: {
        name: "Camera con Vista Montagne",
        size: "22 m²",
        description: "La camera matrimoniale con vista sulle montagne è di circa 22 metri quadri. L'ampio letto matrimoniale offre un riposo rigenerante, mentre le grandi finestre permettono di godere appieno della bellezza del paesaggio circostante."
      },
      balcony: {
        name: "Camera con Balcone e Vista Panoramica",
        size: "24 m²",
        description: "La camera matrimoniale con balcone e vista panoramica sulle montagne, di circa 24 metri quadri, è un perfetto connubio di comfort e bellezza naturale. Il balcone privato offre uno spazio ideale per rilassarsi all'aria aperta."
      },
      family: {
        name: "Camera Famiglia",
        size: "36 m²",
        description: "La camera familiare, perfetta per le vacanze in montagna, è composta da due camere comunicanti con letto matrimoniale e letto a castello, bagno privato con doccia e asciugacapelli."
      },
      amenities: {
        doubleBed: "Letto matrimoniale",
        bathroom: "Bagno privato",
        tv: "TV schermo piatto",
        desk: "Scrivania",
        balcony: "Balcone",
        mountainView: "Vista montagne",
        bunkBed: "Letto a castello"
      }
    },
    services: {
      title: "Servizi & Comfort",
      subtitle: "Tutto per un soggiorno perfetto",
      breakfast: {
        title: "Colazione a Buffet",
        description: "Inizia la giornata con il nostro ricco buffet della colazione o scegli la mezza pensione."
      },
      restaurant: {
        title: "Trattoria Romana",
        description: "Gusta l'autentica cucina romana nel nostro caratteristico ristorante."
      },
      bar: {
        title: "Bar Caratteristico",
        description: "Rilassati nel nostro accogliente bar con area fumatori."
      },
      pets: {
        title: "Pet Friendly",
        description: "I vostri amici a quattro zampe sono i benvenuti (15 CHF al giorno)."
      },
      ski: {
        title: "Skilift Vicino",
        description: "Skilift per bambini a pochi passi. Tutti i comprensori sciistici raggiungibili in autobus o treno."
      },
      golf: {
        title: "Campo da Golf",
        description: "Il rinomato campo da golf dista circa 700 metri."
      }
    },
    location: {
      title: "Posizione & Accessibilità",
      subtitle: "Nel cuore di Samedan, Engadina",
      train: "Stazione ferroviaria ca. 500m",
      bus: "Fermata autobus ca. 100m",
      golf: "Campo da golf ca. 700m",
      ski: "Skilift bambini a pochi passi",
      address: "Via San Bastiaun 25, 7503 Samedan, Svizzera"
    },
    contact: {
      title: "Contatti",
      subtitle: "Saremo lieti di ricevere il vostro messaggio",
      phone: "Telefono / WhatsApp",
      email: "E-mail",
      address: "Indirizzo",
      company: "San Bastiaun Hospitality & Services GmbH",
      companyAddress: "Via Surtour, 1 - 7503 Samedan - CH",
      vatNumber: "CHE-205.322.392"
    },
    footer: {
      followUs: "Seguici",
      rights: "Tutti i diritti riservati"
    },
    gdpr: {
      title: "Impostazioni Cookie",
      description: "Utilizziamo i cookie per offrirti la migliore esperienza sul nostro sito. Puoi scegliere quali cookie accettare.",
      necessary: "Cookie Necessari",
      necessaryDesc: "Questi cookie sono essenziali per il funzionamento del sito.",
      analytics: "Cookie Analitici",
      analyticsDesc: "Ci aiutano a capire come i visitatori interagiscono con il sito.",
      marketing: "Cookie Marketing",
      marketingDesc: "Utilizzati per mostrare pubblicità pertinenti ai visitatori.",
      acceptAll: "Accetta Tutti",
      acceptSelected: "Accetta Selezionati",
      rejectAll: "Rifiuta Tutti",
      settings: "Impostazioni Cookie",
      privacyPolicy: "Informativa Privacy",
      privacyTitle: "Informativa sulla Privacy",
      privacyContent: `
        <h3>1. Titolare del Trattamento</h3>
        <p>San Bastiaun Hospitality & Services GmbH<br/>Via Surtour, 1 - 7503 Samedan - CH<br/>CHE-205.322.392</p>
        
        <h3>2. Raccolta e Trattamento dei Dati</h3>
        <p>Raccogliamo dati personali solo quando ce li fornite volontariamente, ad esempio per una richiesta di prenotazione o per contattarci.</p>
        
        <h3>3. Utilizzo dei Cookie</h3>
        <p>Il nostro sito utilizza cookie. I cookie necessari sono richiesti per le funzioni base del sito. I cookie analitici ci aiutano a capire come viene utilizzato il sito.</p>
        
        <h3>4. I Vostri Diritti</h3>
        <p>Avete il diritto di accesso, rettifica, cancellazione e limitazione del trattamento dei vostri dati. Contattateci a desalpes@sbhsgroup.ch</p>
        
        <h3>5. Contatto</h3>
        <p>Per qualsiasi domanda sulla protezione dei dati, contattateci:<br/>Email: desalpes@sbhsgroup.ch<br/>Tel: +41 78 262 07 40</p>
      `
    },
    chatPopup: {
      title: "Usa la nostra AI",
      description: "Il nostro assistente AI ti aiuterà volentieri per domande su camere, disponibilità e prenotazioni.",
      button: "Avvia AI",
      close: "Più tardi"
    }
  }
};

export const languageNames = {
  de: "Deutsch",
  fr: "Français",
  en: "English",
  it: "Italiano"
};

export const getBookingUrl = (lang) => {
  const langMap = {
    de: 'DE',
    fr: 'FR',
    en: 'EN',
    it: 'IT'
  };
  return `https://www.simplebooking.it/ibe2/hotel/10828?lang=${langMap[lang]}&cur=CHF`;
};

export const detectLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  const supportedLangs = ['de', 'fr', 'en', 'it'];
  return supportedLangs.includes(browserLang) ? browserLang : 'de';
};

export const getChatbotUrl = (lang) => {
  const urls = {
    it: 'https://robottino.telcavoip.net/it/outstanding/user/businesscard/?&id=152854982',
    en: 'https://robottino.telcavoip.net/it/outstanding/user/businesscard/?&id=152854984',
    de: 'https://robottino.telcavoip.net/it/outstanding/user/businesscard/?&id=152854983',
    fr: 'https://robottino.telcavoip.net/it/outstanding/user/businesscard/?&id=152854984'
  };
  return urls[lang] || urls.de;
};
